module.exports = __webpack_public_path__ + "static/media/auto_icon.605e91f3.svg";